if (!window.customElements.get("component-products-slider")) {

class ProductsSlider extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
    this.addListeners();
  }

  initSlider() {
    const swiperParams = {
      slidesPerView: "auto",
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 4.38,
        },
        1600: {
          slidesPerView: 4.6,
        },
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }

  addListeners() {
    document.addEventListener('shopify:section:reorder', () => this.initSlider());
    document.addEventListener('shopify:section:load',() => this.initSlider());
  }
}

  window.customElements.define("component-products-slider", ProductsSlider);
}
